var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-checkbox", {
            attrs: { label: _vm.$ct("extra-field-editable-via-browse-menu") },
            model: {
              value: _vm.value.EditableViaBrowseMenu,
              callback: function ($$v) {
                _vm.$set(_vm.value, "EditableViaBrowseMenu", $$v)
              },
              expression: "value.EditableViaBrowseMenu",
            },
          }),
          _c("w-checkbox", {
            attrs: {
              value: !_vm.value.HideInEditAndInfo,
              label: _vm.$ct("extra-field-show-in-edit-and-info"),
            },
            on: {
              input: function ($event) {
                _vm.value.HideInEditAndInfo = !$event
              },
            },
          }),
          _vm.supportsTabs
            ? _c("w-select", {
                staticClass: "mt",
                attrs: {
                  value: _vm.value.TabID || "",
                  items: _vm.tabItems,
                  label: _vm.$ct("extra-field-tab"),
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    _vm.value.TabID = $event
                  },
                },
              })
            : _vm._e(),
          _vm.isSaleType
            ? _c("app-sale-type-multi-select", {
                attrs: {
                  "use-id": "",
                  label: _vm.$ct("only-show-for-sale-types"),
                  fancy: "",
                  "use-purchase-and-sale": "",
                },
                model: {
                  value: _vm.value.OnlyShownForSaleTypes,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "OnlyShownForSaleTypes", $$v)
                  },
                  expression: "value.OnlyShownForSaleTypes",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }